import { FileUploadDto, TicketModeEnum } from './../../../../../service/dto';
import { ComposeNotificationComponent, WrapperCommunication } from '../../../../../components/compose-notification/compose-notification.component';
import { Component, Input } from '@angular/core';
import { TicketButtonCommunicationDto, TicketButtonDto, TicketDto, TicketStepDto, TicketUploadPayload, CommunicationPlaceholders } from '../../../../../service/dto';
import { NzTabPosition } from 'ng-zorro-antd/tabs';
import { HttpTicketService } from '../../../../../service/http-ticket.service';
import { FormBuilder } from '@angular/forms';
import { HttpFileService } from '../../../../../service/http-file.service';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
	selector: 'app-ticket-communication-modal',
	standalone: false,
	templateUrl: './ticket-communication-modal.component.html',
	styleUrl: './ticket-communication-modal.component.scss'
})
export class TicketCommunicationModalComponent {
	@Input() ticketMode!: TicketModeEnum;
	@Input() step!: TicketStepDto;
	@Input() button!: TicketButtonDto;
	@Input() placeholderValues?: CommunicationPlaceholders;
	@Input() additionalFiles!: { [key: string]: string };

	requiredCommunications: WrapperCommunication[] = [];
	additionalCommunications: WrapperCommunication[] = [];
	selectedCommunication!: WrapperCommunication;
	_communicationIndex = 0;
	addedCounter = 0;
	previewCommunication!: TicketButtonCommunicationDto;
	mode: 'Preview' | 'Compose' = 'Compose';
	defaultFromAddress = '';

	_previewAttachmentSelected = 0;
	previewAttachmentSelected?: FileUploadDto;

	pdfPreviewUrl: SafeUrl | null = null;
	pdfPreviewFilename: string = '';
	isPdfModalVisible = false;

	constructor(
		private fb: FormBuilder,
		private fileService: HttpFileService,
		private ticketService: HttpTicketService,
		private modal: NzModalRef,
		private sanitizer: DomSanitizer) {
	}

	ngOnInit() {
		if (!this.button.additionalCommunications) {
			this.button.additionalCommunications = [];
		}
		this.requiredCommunications = this.button.requiredCommunications
			.sort((i1, i2) => i1.name!.localeCompare(i2.name!))
			.map(item => ComposeNotificationComponent.toWrapper(this.fb, item, this.step, this.additionalFiles));
		this.additionalCommunications = this.button.additionalCommunications
			.sort((i1, i2) => i1.name!.localeCompare(i2.name!))
			.map(item => ComposeNotificationComponent.toWrapper(this.fb, item, this.step, this.additionalFiles));

		this.defaultFromAddress = (this.button.additionalCommunications ?? [])[0]?.emailFrom ?? '';
		if (this.button.onClickComposeAdditionalCommunication && this.additionalCommunications.length == 0) {
			this.addAdditional();
		}
		this.communicationIndex = this.communicationIndex;
	}

	set communicationIndex(input: number) {
		this._communicationIndex = input;
		if (input < this.requiredCommunications.length) {
			this.selectedCommunication = this.requiredCommunications[input];
			this.buildPreview();
		} else {
			this.selectedCommunication = this.additionalCommunications[input - this.requiredCommunications.length];
			this.buildPreview();
		}
	}
	get communicationIndex(): number {
		return this._communicationIndex;
	}


	set previewAttachmentIndex(input: number) {
		this._previewAttachmentSelected = input;
		if (!this.selectedCommunication.payload.attachments) {
			this.previewAttachmentSelected = undefined;
			return;
		}

		if (input >= this.selectedCommunication.payload.attachments.length) {
			input = this.selectedCommunication.payload.attachments.length - 1;
		}
		this._previewAttachmentSelected = input;
		this.previewAttachmentSelected = this.selectedCommunication.payload.attachments[input];

	}
	get previewAttachmentIndex(): number {
		return this._previewAttachmentSelected;
	}
	addAdditional() {

		const communication: TicketButtonCommunicationDto = {
			id: 0,
			actionType: 'AdditionalCommunication',
			type: 'Email',
			name: 'Additional' + (++this.addedCounter),
			attachments: [],
			emailFrom: this.defaultFromAddress,
			emailBcc: '',
			emailBody: '',
			emailCc: '',
			emailSubject: '',
			emailTo: '',
			status: 'Pending',
			hashCode: 0
		};
		this.button.additionalCommunications?.push(communication);
		this.additionalCommunications.push(ComposeNotificationComponent.toWrapper(this.fb, communication, this.step, this.additionalFiles));
		this.communicationIndex = this.requiredCommunications.length + this.additionalCommunications.length - 1;
	}

	removeAdditional({ index }: { index: number }) {
		console.log("Remove")
		this.button.additionalCommunications!.splice(index - this.requiredCommunications.length, 1);
		this.additionalCommunications.splice(index - this.requiredCommunications.length, 1);
		// if( this.requiredCommunications.length==0 && this.additionalCommunications.length==0){
		// this.addAdditional();
		// }
	}
	buildPreview() {
		const payload = this.selectedCommunication.payload as TicketButtonCommunicationDto;
		this.previewCommunication = payload;
		this.ticketService.buildPreview(payload, this.placeholderValues!).subscribe(result => this.previewCommunication = result);
	}
	downloadPreview(attachment: FileUploadDto) {
		(attachment as any).downloading = true;

		const payload = this.selectedCommunication.payload as TicketButtonCommunicationDto;
		this.ticketService.buildAttachmentPreview(attachment, this.placeholderValues!).subscribe({
			next: (result) => {
				const blob = result.body;
				if (blob) {
					const contentDisposition = result.headers.get('Content-Disposition');
					let filename = 'preview';

					if (contentDisposition) {
						const match = contentDisposition.match(/filename="(.+?)"/);
						if (match && match[1]) {
							filename = match[1];
						}
					}

					if (filename.toLowerCase().endsWith('.pdf')) {
						// Show PDF in modal
						const pdfBlob = new Blob([blob], { type: 'application/pdf' });
						const url = URL.createObjectURL(pdfBlob);
						this.openPdfModal(url, filename);
					} else {
						// Download non-PDF files
						const url = URL.createObjectURL(blob);
						const a = document.createElement('a');
						a.href = url;
						a.download = filename;
						a.click();
						URL.revokeObjectURL(url);
					}
				}
				(attachment as any).downloading = false;
			},
			error: (err) => {
				console.error('Download failed:', err);
				(attachment as any).downloading = false;
			}
		});
	}

	openPdfModal(url: string, filename: string) {
		this.pdfPreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
		this.pdfPreviewFilename = filename;
		this.isPdfModalVisible = true;
	}

	closePdfModal() {
		this.isPdfModalVisible = false;
		if (this.pdfPreviewUrl) {
			this.pdfPreviewUrl = null;
		}
	}
	isAttachmentDownloading(attachment: FileUploadDto) {
		return (attachment as any).downloading && (attachment as any).downloading == true;
	}
	// 	this.previewCommunication = {
	// 		id: payload.id,
	// 		actionType: payload.actionType,
	// 		type: payload.type,
	// 		name: payload.name,
	// 		emailFrom: this.replacePlaceholders(payload.emailFrom),
	// 		emailTo: this.replacePlaceholders(payload.emailTo),
	// 		emailCc: this.replacePlaceholders(payload.emailCc),
	// 		emailBcc: this.replacePlaceholders(payload.emailBcc),
	// 		emailSubject: this.replacePlaceholders(payload.emailSubject),
	// 		emailBody: this.replacePlaceholders(payload.emailBody),
	// 		smsMsisdn: this.replacePlaceholders(payload.smsMsisdn),
	// 		smsMessage: this.replacePlaceholders(payload.smsMessage),
	// 		attachments: payload.attachments,
	// 		hashCode: 0
	// 	}
	// }
	// private replacePlaceholders(input?: string): string | undefined {
	// 	if (!input || !this.placeholderValues) {
	// 		return input;
	// 	}

	// 	let result = input;
	// 	for (const key of Object.keys(this.placeholderValues)) {
	// 		const value = this.placeholderValues[key];
	// 		if (value !== undefined && value !== null) {
	// 			const regex = new RegExp(`{{\\s*${key}\\s*}}`, 'gi');
	// 			result = result.replace(regex, value);
	// 		}
	// 	}
	// 	return result;
	// }
	onCancel() {
		this.modal.close(false);
	}
	onSend() {
		this.modal.close(true);
	}
	isValid(): boolean {
		if (this.requiredCommunications.some(item => !item.form.valid)) {
			return false;
		}
		if (this.additionalCommunications.some(item => !item.form.valid)) {
			return false;
		}
		return true;
	}
	getName(input: WrapperCommunication) {
		return (input.payload as TicketButtonCommunicationDto).name;
	}
}
